import { useRouter } from 'next/router';

interface RouterIsReadyProps {
  children: React.ReactNode;
}

const RouterIsReady: React.FC<RouterIsReadyProps> = ({ children }) => {
  const router = useRouter();

  if (!router.isReady) {
    return <></>;
  }

  return <>{children}</>;
};

export default RouterIsReady;
